export default {
  slug: "mellum",
  code: "ML",
  label: "Mellum",
  logoFamily: "jb",
};
